<div class="youtube-download-log-container">
	<div class="filters-row">
		<mat-form-field appearance="outline" class="filter-field">
			<mat-label>{{ 'SETTINGS.YOUTUBE_DOWNLOAD_LOG.FILTER_SOURCE' | translate }}</mat-label>
			<mat-select [(ngModel)]="selectedSourceId" (selectionChange)="onFilterChange()">
				<mat-option [value]="null">{{ 'SETTINGS.YOUTUBE_DOWNLOAD_LOG.ALL_SOURCES' | translate }}</mat-option>
				@for (source of sources; track source.id) {
				<mat-option [value]="source.id">{{ source.name }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="filter-field">
			<mat-label>{{ 'SETTINGS.YOUTUBE_DOWNLOAD_LOG.FILTER_STATUS' | translate }}</mat-label>
			<mat-select [(ngModel)]="selectedStatus" (selectionChange)="onFilterChange()">
				<mat-option [value]="null">{{ 'SETTINGS.YOUTUBE_DOWNLOAD_LOG.ALL_STATUSES' | translate }}</mat-option>
				@for (status of statusOptions; track status) {
				<mat-option [value]="status">{{ 'SETTINGS.YOUTUBE_SOURCE.PREVIEW.STATUS_LABEL.' + status | translate }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>

	@if (loading) {
	<div class="loading-container">
		<mat-spinner></mat-spinner>
	</div>
	} @else {
	@if (dataSource.data.length === 0) {
	<div class="log-empty">
		<mat-icon>history</mat-icon>
		<span>{{ 'SETTINGS.YOUTUBE_DOWNLOAD_LOG.EMPTY' | translate }}</span>
	</div>
	} @else {
	<div class="mat-elevation-z2 px-0">
		<table mat-table [dataSource]="dataSource" class="log-table">
			@for (column of displayedColumns; track $index) {
			<ng-container [matColumnDef]="column">
				<th mat-header-cell *matHeaderCellDef>
					{{ 'SETTINGS.YOUTUBE_DOWNLOAD_LOG.' + column | translate }}
				</th>
				<td mat-cell *matCellDef="let element">
					@switch (column) {
					@case ('DATE') {
					{{ element.createdAt | date: 'dd.MM.yyyy HH:mm' }}
					}
					@case ('SOURCE') {
					{{ element.sourceName }}
					}
					@case ('TITLE') {
					<a [href]="element.videoUrl" target="_blank" rel="noopener">{{ element.videoTitle }}</a>
					}
					@case ('STATUS') {
					<span class="status-badge" [class]="'status-' + element.status.toLowerCase()">
						{{ 'SETTINGS.YOUTUBE_SOURCE.PREVIEW.STATUS_LABEL.' + element.status | translate }}
					</span>
					@if (element.status === 'ERROR' && element.errorMessage) {
					<div class="error-reason">{{ element.errorMessage }}</div>
					}
					}
					}
				</td>
			</ng-container>
			}
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>
		<mat-paginator
			[length]="totalElements"
			[pageSize]="pageSize"
			[pageIndex]="pageIndex"
			[pageSizeOptions]="[20, 50, 100]"
			(page)="onPageChange($event)">
		</mat-paginator>
	</div>
	}
	}
</div>
